import PropTypes from "prop-types";
import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import SectionTitleWithText from "../../components/section-title/SectionTitleWithText";
import BannerOne from "../../wrappers/banner/BannerOne";
import TextGridOne from "../../wrappers/text-grid/TextGridOne";
import FunFactOne from "../../wrappers/fun-fact/FunFactOne";
import TeamMemberOne from "../../wrappers/team-member/TeamMemberOne";
import BrandLogoSliderOne from "../../wrappers/brand-logo/BrandLogoSliderOne";
import FeatureIcon from "../../wrappers/feature-icon/FeatureIcon";

const CondizioniVendita = ({ location }) => {
  const { pathname } = location;
  var strings = require("../../translations/italian.json");
  var informazioni = global.informazioni;

  return (
    <Fragment>
      <MetaTags>
        <title>Condizioni di vendita | {informazioni.titleSite}</title>
        <meta
          name="description"
          content={"Condizioni di vendita" + " " + strings.siteContent}
        />
      </MetaTags>

      <LayoutOne>
        <Breadcrumb />

        {/* Stili CSS locali per forzare elenchi puntati e dimensioni font scavalcando i reset del template */}
        <style>
          {`
            .terms-content ul {
              list-style-type: disc !important;
              padding-left: 40px !important;
              margin-bottom: 20px !important;
            }
            .terms-content li {
              display: list-item !important;
              margin-bottom: 8px !important;
              line-height: 1.6;
            }
            .terms-content h1 {
              font-size: 2.2rem !important;
              margin-bottom: 25px !important;
              font-weight: bold !important;
              text-align: center;
            }
            .terms-content h2 {
              font-size: 1.5rem !important;
              color: #0056b3 !important;
              margin-top: 35px !important;
              margin-bottom: 15px !important;
              font-weight: 700 !important;
            }
            .terms-content h3 {
              font-size: 1.25rem !important;
              margin-top: 25px !important;
              margin-bottom: 10px !important;
              font-weight: 600 !important;
            }
            .terms-content p {
              line-height: 1.7 !important;
              margin-bottom: 15px !important;
            }
          `}
        </style>

        <div
          className="terms-content"
          align="justify"
          style={{ paddingLeft: "20%", paddingRight: "20%" }}
        >
          <center>
            <h2>
              Condizioni Generali di Vendita
              <br />
              <u>D.G.A. PLANET SHIRT S.R.L.</u>
            </h2>
          </center>
          <p>&nbsp;</p>
          <h1>CONDIZIONI GENERALI DI VENDITA (B2B)</h1>

          <p>Le presenti condizioni regolano esclusivamente i rapporti commerciali tra operatori professionali (B2B).</p>
          <p>L'invio dell'ordine comporta l'accettazione integrale delle presenti condizioni. Eventuali condizioni di acquisto del cliente non si applicano, anche se indicate negli ordini o in altri documenti.</p>

          <h2>1. Prezzi</h2>
          <p>Tutti i prezzi sono espressi in Euro (€), per singolo pezzo, IVA esclusa. Per alcuni articoli determinate taglie o colori possono avere un prezzo differente. In tal caso verrà applicato il prezzo specifico della taglia o del colore ordinato, indipendentemente dalla quantità totale. Fa fede il prezzo in vigore al momento dell'ordine.</p>

          <h2>2. Condizioni commerciali agevolate</h2>
          <p>Eventuali condizioni favorevoli (sconti, prezzi riservati, spedizioni gratuite o pagamenti agevolati) non sono permanenti né acquisite. In caso di riduzione o interruzione degli acquisti, il venditore si riserva il diritto di modificarle o revocarle, applicando le condizioni in vigore al momento del nuovo ordine.</p>

          <h2>3. Ordini</h2>
          <p>Gli ordini non si accettano verbalmente o telefonicamente. Devono essere inviati esclusivamente tramite sito.</p>

          <h3>Modalità di evasione</h3>
          <ul>
            <li><strong>Spedizione a ordine completo:</strong> L'ordine verrà spedito solo quando tutti gli articoli saranno disponibili, con un solo costo di trasporto.</li>
            <li><strong>Disponibile e restante all'arrivo:</strong> La merce disponibile viene spedita subito. La restante parte verrà spedita alla disponibilità. Ogni spedizione comporta nuovi costi di trasporto. La merce in prenotazione non può essere unita ad altri ordini.</li>
          </ul>

          <p>Gli ordini già evasi, in lavorazione o prenotati non possono essere annullati. Eventuali richieste di annullamento, se accettate, comporteranno l'addebito del 10% dell'imponibile dell'ordine per spese di gestione.</p>

          <h2>4. Modalità di pagamento</h2>
          <p>Le modalità di pagamento e spedizione sono definite nell'anagrafica cliente e gestite tramite sistema automatico. Eventuali richieste di variazione per un singolo ordine devono essere obbligatoriamente inserite nelle NOTE DELL'ORDINE prima della spedizione. Saranno considerate valide solo le richieste presenti nelle note e solo previa nostra conferma scritta. In assenza di note o conferma scritta, l'ordine verrà evaso secondo le condizioni standard del cliente. Eventuali costi aggiuntivi (compresi quelli per variazione o annullamento del contrassegno) restano a carico del cliente.</p>

          <h2>5. Pagamenti</h2>
          <p>Il pagamento in contrassegno avviene al momento della consegna. Eventuali dilazioni devono essere concordate per iscritto.</p>
          <p>In caso di insoluto verranno addebitate le seguenti spese:</p>
          <ul>
            <li>€ 20,00 per assegno bancario</li>
            <li>€ 10,00 per ricevuta bancaria</li>
          </ul>
          <p>Saranno inoltre applicati gli interessi di legge e potranno essere revocate eventuali condizioni agevolate. In presenza anche di un solo insoluto, il venditore si riserva il diritto di modificare o revocare eventuali condizioni di pagamento favorevoli concesse al cliente, applicando modalità di pagamento anticipate o più restrittive. Anche un solo insoluto autorizza il venditore a sospendere o annullare forniture in corso.</p>

          <h2>6. Trasporto, spedizioni e ritiri</h2>
          <p>Salvo diverso accordo scritto, il trasporto è a carico del cliente. La merce viaggia sempre a rischio del cliente, anche in caso di spedizione in porto franco.</p>

          <h3>Spedizioni:</h3>
          <ul>
            <li>porto assegnato (qualora il cliente disponga di proprio contratto con corriere)</li>
            <li>oppure tramite nostro corriere convenzionato con addebito in fattura</li>
          </ul>
          <p>Per ordini con imponibile minimo di € 400,00 la spedizione è in porto franco.</p>

          <h3>Tariffe indicative Italia:</h3>
          <ul>
            <li>1° collo € 12,90</li>
            <li>2° collo € 6,00</li>
            <li>successivi € 4,00</li>
            <li>contrassegno € 2,00</li>
          </ul>

          <h3>Spese imballaggio:</h3>
          <ul>
            <li>€ 1,00 per ogni spedizione</li>
            <li>€ 2,00 in caso di ritiro merce (sia con corriere incaricato dal cliente sia con ritiro diretto presso la nostra sede)</li>
          </ul>

          <h3>Supplemento spedizioni Isole Minori</h3>
          <p>Per le spedizioni dirette verso isole minori, zone franche o località soggette a inoltro via traghetto, è previsto un supplemento di € 6,00 per spedizione, applicato dal corriere.</p>

          <h2>7. Giacenze e variazioni</h2>
          <p>In caso di mancata consegna, rifiuto merce, assenza destinatario o indirizzo errato, tutte le spese sono a carico del cliente, inclusi:</p>
          <ul>
            <li>spese di giacenza € 10,00</li>
            <li>riconsegna: stesso costo previsto per la spedizione originaria</li>
            <li>variazione indirizzo € 6,00</li>
            <li>variazione porto € 6,00</li>
            <li>variazione o annullamento contrassegno € 6,00</li>
          </ul>
          <p>Gli importi sopra indicati si intendono per singola operazione.</p>

          <p>In caso di rientro merce saranno addebitati:</p>
          <ul>
            <li>trasporto di andata e ritorno</li>
            <li>giacenza</li>
          </ul>
          <p>Qualora il rientro merce sia dovuto a richiesta del cliente o a cause non imputabili al venditore, si applicherà inoltre quanto previsto al punto 3, con addebito del 10% dell'imponibile dell'ordine per spese di gestione.</p>

          <h2>8. Disponibilità prodotti</h2>
          <p>La disponibilità degli articoli può variare senza preavviso. L'inserimento di un prodotto nel catalogo o sul sito non garantisce la sua costante disponibilità. I tempi di consegna sono indicativi e possono subire variazioni per cause non dipendenti dal venditore. Eventuali ritardi non danno diritto a risarcimenti o annullamenti dell'ordine.</p>

          <h2>9. Controllo della merce</h2>
          <p>Il cliente è tenuto a controllare la merce al momento della consegna. Eventuali danni devono essere segnalati immediatamente al corriere con riserva scritta dettagliata sul documento di trasporto (DDT). Eventuali contestazioni devono essere inviate via e-mail entro 8 giorni dal ricevimento della merce. Trascorso tale termine la merce si considera accettata. È vietato personalizzare o stampare la merce prima del controllo.</p>

          <h2>10. Resi</h2>
          <p>Non si accettano resi non autorizzati. La merce personalizzata, stampata o modificata non può essere resa in alcun caso.</p>
          <p>Per resi autorizzati non imputabili al venditore:</p>
          <ul>
            <li>spese gestione reso € 10,00</li>
            <li>trasporto a carico del cliente</li>
          </ul>
          <p>La merce deve essere restituita nell'imballo originale, integra e completa.</p>

          <h2>11. Caratteristiche tecniche</h2>
          <p>Per esigenze produttive, lotti diversi possono presentare leggere variazioni di tonalità colore o vestibilità.</p>
          <h3>Tolleranze:</h3>
          <ul>
            <li>grammatura ± 5%</li>
            <li>misure taglie ± 2,5 cm</li>
          </ul>
          <p>Le immagini e i colori riprodotti su cataloghi o materiali promozionali hanno valore indicativo.</p>

          <h2>12. Immagini e materiale promozionale</h2>
          <p>Rendering, mockup, fotografie e ambientazioni presenti su catalogo, sito o altri materiali hanno valore puramente illustrativo e non costituiscono elemento contrattuale. L'azienda non è responsabile per eventuali errori di stampa, refusi o omissioni.</p>

          <h2>13. Forza maggiore</h2>
          <p>Il venditore non è responsabile per ritardi o mancata consegna dovuti a cause di forza maggiore, tra cui scioperi, interruzioni dei trasporti, incendi, eventi naturali, pandemie, carenza di materie prime o provvedimenti delle autorità. Tali eventi non danno diritto a risarcimenti o annullamenti. La presente clausola si applica anche nel caso in cui eventuali ritardi riguardino merce ordinata presso fornitori del venditore.</p>

          <h2>14. Disposizioni finali</h2>
          <p>Per quanto non espressamente previsto nelle presenti condizioni, si applicano le norme del Codice Civile italiano.</p>

          <h3>Foro competente</h3>
          <p>Per qualsiasi controversia relativa ai rapporti commerciali tra le parti sarà competente in via esclusiva il Foro di Torre Annunziata.</p>
        </div>

        <BrandLogoSliderOne spaceBottomClass="pb-70" />
      </LayoutOne>
    </Fragment>
  );
};

CondizioniVendita.propTypes = {
  location: PropTypes.object,
};

export default CondizioniVendita;